import { j as s, I as L, B as v, T as _ } from "./Spinner-yxPaS-Vf.js";
import { L as V } from "./LandingPageTag-8br2srXG.js";
import k, { useRef as M, useState as P, useEffect as q } from "react";
import { css as a, styled as n } from "styled-components";
import { j as c, e as p, s as y, c as o, r as e, p as d, d as j, o as D, T as H, l as O } from "./style-ImpGK6sv.js";
import { d as S, e as r, z as W } from "./index-tc-On6zr.js";
import { u as F } from "./useUuid-Vpcmoafn.js";
import { T as N } from "./icon-tick-FmNJhlC4.js";
import { L as U, a as G } from "./LoadMore-AVtAOuRr.js";
import { R as J } from "./RangeSlider-UEtWvwxX.js";
import { S as K } from "./ShowMore-jTGWFK_P.js";
const $ = a`
  ${c("opacity", p.shortest)};
  ${y("100%")};

  display: block;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 0;
  background-color: ${o.black};
  content: '';
`, Q = a`
  ${c("opacity", p.shortest)};
  ${y(e(16))}

  top: calc(50% - ${e(16)} / 2);
  left: calc(50% - ${e(16)} / 2);
  opacity: 0;
  border-radius: ${S.sm};
  background-color: ${o.black};
`, X = a`
  display: block;
  position: absolute;
  bottom: ${e(r.spacer1)};
  left: ${e(r.spacer1)};
  background-color: ${o.greyAlpha10};
  width: calc(100% - ${e(r.spacer3)} / 2);
  height: 1px;
  content: '';

  ${d(a`
    forced-color-adjust: preserve-parent-color;
    ${j("background-color", "accentAlpha10")};
  `)}
`, Y = n.label`
  ${D(H.bodyMedium)};

  display: flex;
  position: relative;
  cursor: pointer;
  padding: ${e(r.spacer3)} 0 ${e(r.spacer3)} ${e(r.spacer7)};
  font-weight: ${O.normal};

  /* Simulated border bottom */
  ${({ $hasSeparator: t }) => t && a`
      &::after {
        ${X}
      }
    `}

  /* Error state */
  ${({ $error: t }) => t && a`
      > span:nth-of-type(1) {
        border: 1px solid ${o.redAlert};
      }
    `}

  span:nth-of-type(1)::before {
    ${Q}
  }

  /* Disabled states. */
  ${({ $disabled: t }) => t ? a`
          cursor: not-allowed;

          > span:nth-of-type(1) {
            border: 1px solid ${o.greyAlpha40};

            ${d(a`
              border: 1px solid ${o.greyAlpha40};
            `)}

            &::before {
              background-color: ${o.transparent};
            }
          }

          > span:nth-last-child(1) {
            color: ${o.greyAlpha40};
          }
        ` : a`
          /* Active state */
          &:active {
            > span:nth-of-type(1) {
              border: 1px solid ${o.greyAlpha60};
            }

            > span:nth-last-child(1) {
              color: ${o.greyAlpha60};
            }
          }

          /* Hover state, exclude touch events */
          [data-whatintent='mouse'] & {
            &:hover {
              span:nth-of-type(1) {
                border: 1px solid ${o.black};

                ${d(a`
                  border-color: currentColor;
                `)}
              }

              span:nth-last-child(1) {
                text-decoration: underline;
              }
            }
          }
        `}

  /* Show "outline" when focused by keyboard only */
  [data-whatintent='keyboard'] &:focus-within {
    outline: 1px solid;
    ${j("outline-color", "dominant")};
    outline-offset: -1px;
  }
`, Z = n.input`
  /* Visually hide native checkbox */
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;

  /* Checked state */
  &:checked {
    ~ span:nth-of-type(1) {
      background-color: ${o.black};

      &::before {
        ${$};
        opacity: 1;
      }

      div {
        opacity: 1;
      }
    }
  }

  /* Checked - disabled state */
  &:checked:disabled {
    + span:nth-of-type(1) {
      opacity: 0.4;
      border: 1px solid ${o.greyAlpha40};

      &::before {
        ${$};
        opacity: 0.4;
      }
    }
  }
`, oo = n.span`
  ${y(e(24))}

  display: block;
  position: absolute;
  top: ${e(r.spacer3)};
  left: ${e(3)};
  border: 1px solid ${o.greyAlpha60};
  border-radius: ${S.sm};

  &::before {
    ${$}
    ${c("opacity", p.shortest)};
  }

  /* Icon wrapper */
  div {
    ${c("opacity", p.shorter)};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
  }

  ${d(a`
    forced-color-adjust: preserve-parent-color;
    border-color: currentColor;
  `)}
`, eo = n.span`
  display: block;
  padding-top: ${e(2)};
  min-height: ${e(24)};
`, w = k.forwardRef(
  ({ disabled: t = !1, checked: i = !1, name: h, text: b, value: C, error: A = !1, onChange: m, hasSeparator: T = !1 }, z) => {
    const I = M(null), [f, u] = P(i), x = F();
    q(() => {
      u(i);
    }, [i]);
    const R = (l, E) => {
      const g = !E;
      u(g), m && m(l, g);
    }, B = (l) => {
      if (R(l, f), t) {
        l.stopPropagation(), l.preventDefault();
        return;
      }
    };
    return k.useImperativeHandle(z, () => ({
      setValue: u,
      getValue: () => f
    })), /* @__PURE__ */ s.jsxs(
      Y,
      {
        htmlFor: x,
        $error: A,
        $disabled: t,
        $hasSeparator: T,
        "data-qa": "checkbox",
        children: [
          /* @__PURE__ */ s.jsx(
            Z,
            {
              ref: I,
              name: h,
              "aria-disabled": t && !i,
              checked: f,
              disabled: t,
              type: "checkbox",
              id: x,
              value: C,
              onChange: B
            }
          ),
          /* @__PURE__ */ s.jsx(oo, { children: /* @__PURE__ */ s.jsx(L, { color: "white", size: "xs", icon: N }) }),
          /* @__PURE__ */ s.jsx(eo, { "data-qa": "checkbox-text", children: b })
        ]
      }
    );
  }
);
w.displayName = "Checkbox";
const to = n.div`
  display: inline-block;
  position: fixed;
  top: 0;
  left: 0;
  visibility: hidden;
  z-index: ${W.insane};
  padding: ${r.spacer3};
`, ao = n(v)`
  position: relative;
  top: -${r.spacer10};
  visibility: visible;
  opacity: 0;
  ${c("opacity, top", p.shortest)};

  &:focus {
    top: 0;
    opacity: 1;
  }
`, ro = ({ text: t, theme: i, href: h, ariaLabel: b }) => /* @__PURE__ */ s.jsx(_, { theme: i, children: t ? /* @__PURE__ */ s.jsx(to, { as: "nav", "aria-label": b, children: /* @__PURE__ */ s.jsx(ao, { href: h, children: t }) }) : null }), yo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: v,
  Checkbox: w,
  LandingPageTag: V,
  LoadMore: U,
  LoadingBar: G,
  RangeSlider: J,
  ShowMore: K,
  SkipContent: ro
}, Symbol.toStringTag, { value: "Module" }));
export {
  w as C,
  ro as S,
  yo as i
};
